import { render, staticRenderFns } from "./CompraParciais.vue?vue&type=template&id=4b43b9d6&scoped=true"
import script from "./CompraParciais.vue?vue&type=script&lang=js"
export * from "./CompraParciais.vue?vue&type=script&lang=js"
import style0 from "./CompraParciais.vue?vue&type=style&index=0&id=4b43b9d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43b9d6",
  null
  
)

export default component.exports